import RoutesPath from '@router/routes';

const routes = [
  {
    path: RoutesPath.private.users.list,
    label: 'Lista de usuários',
  },
  {
    path: RoutesPath.private.users.detail,
    label: 'Detalhes do usuário',
  },
];

export default routes;
